// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__IXAGr","inner":"Footer_inner__Sjnua","links":"Footer_links__jgQgA"};